import { csx, cx, Flex, Text } from '@vtex/admin-ui'
import type { DefaultProps } from 'typings'
import styles from './section.css'

export function Section(props: DefaultProps) {
  return <div className={styles.section}>{props.children}</div>
}

export function SectionHeader(props: DefaultProps) {
  return (
    <Flex justify="space-between" align="center">
      {props.children}
    </Flex>
  )
}

export function SectionTitle(props: DefaultProps) {
  return <Text variant="title1">{props.children}</Text>
}

export function SectionContent(
  props: DefaultProps & {
    /**
     * If the items should grow in width to match the container
     * @param fluid
     */
    fluid?: boolean
    space?: string
    className?: string
  }
) {
  const { fluid, space, className = '' } = props

  return (
    <Flex
      align="flex-start"
      className={cx(styles.content, className, csx({ gap: space }))}
      data-fluid={fluid}
    >
      {props.children}
    </Flex>
  )
}
